import { createAction, props } from '@ngrx/store';

import { AnimalGroup, FeedAdviceApplication } from '../models/animal-group.model';

export const clearAnimalGroupState = createAction('[AnimalGroup] Clears the AnimalGroup state');

export const loadData = createAction('[AnimalGroup] Load data');
export const loadAnimalGroupsRequest = createAction('[AnimalGroup] Load AnimalGroups request');
export const loadAnimalGroupsSuccess = createAction(
  '[AnimalGroup] Load AnimalGroups success',
  props<{ animalGroups: AnimalGroup[] }>(),
);
export const loadAnimalGroupsFailed = createAction(
  '[AnimalGroup] Load AnimalGroups failed',
  props<{ error: Error }>(),
);

export const createAnimalGroup = createAction(
  '[AnimalGroup] Create animalGroup',
  props<{ animalGroup: AnimalGroup }>(),
);

export const upsertAnimalGroupGeneral = createAction(
  '[AnimalGroup] Upsert animalGroup general',
  props<{ animalGroup: AnimalGroup }>(),
);

export const upsertAnimalGroupRequest = createAction(
  '[AnimalGroup] Upsert animalGroup request',
  props<{ animalGroup: AnimalGroup }>(),
);
export const upsertAnimalGroupSuccess = createAction(
  '[AnimalGroup] Upsert animalGroup success',
  props<{ animalGroup: AnimalGroup }>(),
);
export const upsertAnimalGroupFailed = createAction(
  '[AnimalGroup] Upsert animalGroup failed',
  props<{ error: Error }>(),
);

export const deleteAnimalGroupRequest = createAction(
  '[AnimalGroup] Delete animalGroup request',
  props<{ animalGroup: AnimalGroup }>(),
);
export const deleteAnimalGroupWithConfirmation = createAction(
  '[AnimalGroup] Confirm Delete animalGroup',
  props<{ animalGroup: AnimalGroup }>(),
);
export const deleteAnimalGroupSuccess = createAction(
  '[AnimalGroup] Delete animalGroup success',
  props<{ animalGroup: AnimalGroup }>(),
);
export const deleteAnimalGroupFailed = createAction(
  '[AnimalGroup] Delete animalGroup failed',
  props<{ error: Error }>(),
);

// FEEDADVICE APPLICATIONS
export const setSelectedFeedadviceApplicationId = createAction(
  '[FeedadviceApplication] Set selected FeedadviceApplication',
  props<{ id?: number }>(),
);
export const addFeedadviceApplication = createAction(
  '[FeedadviceApplication] Add FeedadviceApplication',
  props<{ animalGroupId: number; feedAdviceApplication: FeedAdviceApplication }>(),
);
export const editFeedadviceApplication = createAction(
  '[FeedadviceApplication] Edit FeedadviceApplication',
  props<{ animalGroupId: number; feedAdviceApplication: FeedAdviceApplication }>(),
);
export const deleteFeedadviceApplicationWithConfirmation = createAction(
  '[FeedadviceApplication] Confirm delete FeedadviceApplication',
  props<{ animalGroupId: number; id: number }>(),
);
export const deleteFeedadviceApplication = createAction(
  '[FeedadviceApplication] Delete FeedadviceApplication',
  props<{ animalGroupId: number; id: number }>(),
);
